import React, { useContext } from 'react';
import { Field } from 'formik';
import { FormContext } from './FormContext';

const RadioField = React.forwardRef((props, ref) => {
  const context = useContext(FormContext);
  const { disabled, readOnly } = context ? context : {};
  const extProps = { disabled, readOnly, ...props };

  return (
    <Field
      {...props}
      ref={ref}
      render={({ field: { name, value, onChange, onBlur } }) => {
        return (
          <input
            name={name}
            id={props.id}
            type="radio"
            value={props.id} // could be something else for output?
            checked={props.id === value}
            onChange={onChange}
            onBlur={onBlur}
            {...extProps}
          />
        );
      }}
    />
  );
});

RadioField.displayName = 'RadioField';
export default RadioField;
